import { PDFFillerContext } from 'pages/Contexts/PdfFillerContext'
import * as React from 'react'

import { ConsumerProps } from './types'

function FormBuilderSettingsGeneralDocumentConsumer({
  children,
}: ConsumerProps) {
  const {
    documentDownloadable,
    setDocumentDownloadable,
    pdfReportType,
    setPdfReportType,
    setAutoSignOffEnabled,
    autoSignOffEnabled,
    setElationPdfNonFax,
    elationPdfNonFax,
    internalForm,
    setInternalForm,
  } = React.useContext(PDFFillerContext)

  return children({
    autoSignOffEnabled,
    elationPdfNonFax,
    formDownloadable: documentDownloadable,
    formReportType: pdfReportType,
    internalForm,
    setAutoSignOffEnabled,
    measuresEnabledForm: false,
    setElationPdfNonFax,
    setFormDownloadable: (checked) => setDocumentDownloadable(checked),
    setFormReportType: (value) => setPdfReportType(value || null),
    setInternalForm,
    setMeasuresEnabledForm: () => null,
    setIsDirty: () => null,
  })
}

export default FormBuilderSettingsGeneralDocumentConsumer
